import { textFormatting } from '@yola/ws-sdk';
import constants from '../constants';

const { AI_REWRITE_TEXT_MIN_SYMBOLS_LENGTH } = constants.common;

const isAiRewriteCollapsedTextAllowed = () => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { anchorNode } = selection;

  if (!anchorNode) {
    return false;
  }

  const closestContentEditableElement = anchorNode.parentElement.closest('[contenteditable]');

  if (!closestContentEditableElement) {
    return false;
  }

  return Array.from(closestContentEditableElement.children).some(
    (child) => child.textContent.trim()?.length > AI_REWRITE_TEXT_MIN_SYMBOLS_LENGTH
  );
};

export default isAiRewriteCollapsedTextAllowed;
